import axios from 'axios';

function getTextByResult(score) {
    const correctlyAnswered = [
        'Это верный ответ!',
        'Правильно!',
        'Отлично! Продолжайте!',
        'Превосходно!',
        'Замечательно!',
        'Это фантастика! Великолепный результат!',
        'Искусственный интеллект аплодирует вам!',
        'Впечатляет!!!',
        'Отлично! Не все знают ответ на этот вопрос!',
        'Вы на пути к триумфу!'
    ];
    const wrongAnswer = [
        'К сожалению, это неверно.',
        'Жаль! Вы были близки к правильному ответу.',
        'Неправильно. Придется повторить материал.',
        'А вы точно это учили?',
        'Соберитесь! Вы теряете баллы!',
        'Может, со следующим вопросом получится лучше?',
        'А вот и нет!',
        'Неверно! Надо бы повторить эту тему.',
        'Каждая ваша ошибка причиняет мне боль. Не делайте так!',
        'Ошибаться - это нормально, но впредь будьте внимательнее.'
    ];
    
    let index = 0;

    if(score <= 0) {
        index = Math.floor(Math.random() * wrongAnswer.length);

        return wrongAnswer[index]
    }
    if(score >= 1)  {
        index = Math.floor(Math.random() * correctlyAnswered.length);

        return correctlyAnswered[index]
    }

    return ''
}

export default {
	namespaced: true,
	state: {
        mobileFlag: false,
        resultId: null,
		resultObject: {
            studyDisciplineName: '',
            description: '',
            createdDate: null,
            title: '',
            patient: {
                logoUrl: '',
                gender: 0,
                episodes: [
                    {
                        ageValue: 0
                    }
                ]
            },
            score: 0,
            criteries: []
        }
	},
	getters: {
		getResultObject: state => state.resultObject
	},
	mutations: {
        saveIdResult(state, id) {
            state.resultId = id;
        },
		setResultObject(state, data) {
			for (let i = 0; i < data.criteries.length; i++) {
                data.criteries[i].scoreText = getTextByResult(data.criteries[i].score);
                data.criteries[i].isOpen = false;
                data.criteries[i].showAnswer = false;

                if(data.criteries[i].title === 'Время диагностики'){
                    data.criteries[i].result = data.timer
                }
            }

            state.resultObject = data;
        }
	},
	actions: {
		getDiaTestProcessResult({ state, commit, rootState }, resultId) {
			return new Promise((resolve, reject) => {
				axios.get(`${rootState.api}DiaTestProcess/GetDiaTestProcessResult?resultId=${resultId ? resultId : state.resultId}`)
				.then(resp => {
                    resolve(true)
					commit('setResultObject', resp.data)
				}).catch(err => {
					reject(err)
				})
			})
		}
	}
};
